import type { WorkflowRequest } from '../model';
import { approvalLinePreviews } from '../models/workflowRequestPageModel';
import { fixtureWorkflowApprovalRoles, fixtureWorkflowEmployeeDirectory } from './workflowPageFixtures';

export function submitFixtureWorkflowRequest(draft: WorkflowRequest, requesterWorkerId?: string): WorkflowRequest {
  const steps = draft.draftApprovalSteps ?? [];
  const previews = approvalLinePreviews(steps, fixtureWorkflowEmployeeDirectory, requesterWorkerId, fixtureWorkflowApprovalRoles, {
    directoryLoading: false, rolesLoading: false,
  });
  const firstStage = Math.min(...steps.map((step) => step.stageOrder));
  const submittedAt = new Date().toISOString();
  return {
    ...structuredClone(draft), status: 'IN_PROGRESS', submittedAt, updatedAt: submittedAt,
    approvalSteps: steps.map((step, index) => ({
      order: step.order, stageOrder: step.stageOrder, label: step.label,
      approvalLabelId: step.approvalLabelId, approvalLabel: step.approvalLabel,
      assigneeType: step.resolverType === 'FIXED_ROLE' ? 'ROLE' : 'PERSON',
      assigneeId: step.resolverType === 'FIXED_ROLE'
        ? String(step.resolverConfig?.roleCode ?? '') : previews[index]?.personID ?? '',
      status: step.stageOrder === firstStage ? 'IN_PROGRESS' : 'PENDING',
    })),
  };
}
